module.exports = __webpack_public_path__ + "static/work_icon_dev_iot-865bce1733cfa947a3667e27c963fda6.png";